import { useTranslation } from "react-i18next";
import { useLogoutUserMutation } from "../api/userAuthApi";
import { useMutationWithFeedback } from "../../../common/hooks/useMutationWithFeedback";
// Import the token saver from api.ts to clear client-side state
import { saveCartTokenToStorage } from "../../../app/api";

export const useUserLogout = () => {
  const { t } = useTranslation();
  const [logoutUser, result] = useLogoutUserMutation();

  const { trigger, isLoading } = useMutationWithFeedback({
    mutation: [logoutUser, result],
    // Loading/Success messages handled here.
    loadingMessage: t("user.auth.loggingOut", "Logging out..."),
    successMessage: null, // We reload immediately, no need for toast
    errorMessages: {
      default: t("feedback.default.error", "An error occurred."),
    },
  });

  const handleLogout = async () => {
    const response = await trigger();

    // Whether the API call succeeded or failed (fallback), we proceed to clear client state.
    if (response.success || response.error) {
      // 1. Clear the Cart Token from LocalStorage
      // This is crucial. It ensures the next request (as a guest) doesn't send the old
      // user's token, forcing the backend to generate a fresh, empty session.
      saveCartTokenToStorage(null);

      // 2. Reload the page
      // This resets all React state (Redux store) and ensures WordPress nonces are refreshed.
      window.location.reload();
    }
  };

  return { handleLogout, isLoading };
};
